import { IsNotEmpty } from 'common/validation/decorators/IsNotEmpty'
import { FormModel } from '../../../../../common/form-state-manager/classes/FormModel'

/**
 * VALIDADOR para form de alteracao de senha
 */
export class ChangePasswordFormValidator extends FormModel {

    @IsNotEmpty()
    currentPassword: string

    @IsNotEmpty()
    newPassword: string

    @IsNotEmpty()
    confirmNewPassword: string

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
